/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashFrontendServiceGetExperiments} from '../api'

export const useMutationCashFrontendServiceGetExperiments = createReactQueryMutationHook('cashFrontendServiceGetExperiments', cashFrontendServiceGetExperiments)
